import { Model } from 'json-api-models';

import type { Models, Schemas } from '../models.ts';

export class VideoProgress extends Model<Schemas['videoProgress'], Models> {
    get updatedAtDate() {
        return new Date(this.updatedAt!);
    }
}

export type VideoWatchProgress = Pick<VideoProgress, 'progress' | 'positionSeconds'>;
